/* Ola Azul — search field for the country / currency selector */
(function () {
  var norm = function (s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  };

  function enhance(popover) {
    if (popover.dataset.oaSearch) return;
    var form = popover.querySelector('form.shopify-localization-form');
    if (!form || !form.querySelector('button[name="country_code"]')) return;
    popover.dataset.oaSearch = '1';

    var options = Array.prototype.slice.call(form.querySelectorAll('button[name="country_code"]'));
    options.forEach(function (o) {
      var img = o.querySelector('img');
      // country name only (no currency), so "eur" doesn't list every euro country
      o.dataset.oaTerms = ' ' + norm((img && img.alt) || o.textContent.replace(/\(.*\)/, '')).replace(/[^a-z0-9]+/g, ' ');
    });

    var lang = (document.documentElement.lang || 'en').slice(0, 2);
    var wrap = document.createElement('div');
    wrap.className = 'oa-country-search';
    wrap.innerHTML =
      '<input type="search" autocomplete="off" spellcheck="false" aria-label="' +
      (lang === 'es' ? 'Buscar país' : 'Search country') + '" placeholder="' +
      (lang === 'es' ? 'Buscar país' : 'Search country') + '">' +
      '<p class="oa-country-search__empty" hidden>' +
      (lang === 'es' ? 'Sin resultados' : 'No results') + '</p>';

    form.parentNode.insertBefore(wrap, form);

    var input = wrap.querySelector('input');
    var empty = wrap.querySelector('.oa-country-search__empty');

    input.addEventListener('input', function () {
      var q = norm(input.value), shown = 0;
      options.forEach(function (o) {
        // match from the start of any word: "spa" -> Spain, "states" -> United States
        var hit = !q || o.dataset.oaTerms.indexOf(' ' + q) !== -1 || o.value.toLowerCase() === q;
        o.hidden = !hit;
        o.style.display = hit ? '' : 'none';
        if (hit) shown++;
      });
      empty.hidden = shown !== 0;
    });

    input.addEventListener('keydown', function (e) {
      e.stopPropagation();
      if (e.key === 'Enter') {
        e.preventDefault();
        var first = options.filter(function (o) { return !o.hidden; })[0];
        if (first) first.click();
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        var f = options.filter(function (o) { return !o.hidden; })[0];
        if (f) f.focus();
      }
    });

    // focus the field when the selector opens; reset when it closes
    var reset = function () {
      if (!input.value) return;
      input.value = '';
      input.dispatchEvent(new Event('input'));
    };
    new MutationObserver(function () {
      if (popover.hasAttribute('open')) {
        setTimeout(function () { if (window.matchMedia('(hover: hover)').matches) input.focus(); }, 120);
      } else reset();
    }).observe(popover, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    document.querySelectorAll('x-popover').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
